'use client';

import { QueryKeys } from '@/constants/query-keys';
import { mediaApiService } from '@/services/(frontend)/media/media-api.service';
import { Media } from '@cinemark/content-api-client';
import { useQuery } from '@tanstack/react-query';
import { useDynamicStaleTime } from '../shared/dynamic-stale-time';

export const useMedia = (
  mediaId: string
): ReturnType<typeof useQuery<Media | null>> => {
  const updateQueryStaleTime = useDynamicStaleTime();

  return useQuery<Media | null>({
    enabled: !!mediaId,
    queryFn: async ({ signal }) => {
      if (!mediaId) return null;

      try {
        const response = await mediaApiService.getMedia(mediaId, signal);

        if (response.headers) {
          updateQueryStaleTime(QueryKeys.global.media(mediaId), response.headers);
        }

        return response.data;
      } catch {
        return null;
      }
    },
    queryKey: QueryKeys.global.media(mediaId),
  });
};
